module.exports = __webpack_public_path__ + "img/SUPEROK_7.b1571c7f.jpg";